import type {
    AuthorizedMedicationInfoFragment,
    MedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../graphql/generated/graphql';
import type { MedicationOverride } from '../hooks/use-config-api';

type MedicationFragment =
    | AuthorizedMedicationInfoFragment
    | MedicationInfoFragment
    | UnknownMedicationInfoFragment;

export const getMedicationNdc = (
    medication: MedicationFragment | MedicationOverride | undefined
): string | undefined => {
    if (!medication) {
        return;
    }

    return Object.hasOwn(medication, '__typename')
        ? (medication as MedicationFragment).__typename === 'UnknownMedication'
            ? (medication as UnknownMedicationInfoFragment).originalNdc ||
              medication.id
            : medication.id
        : (medication as MedicationOverride).ndc;
};
